import {TESTS, getValue} from '../../../../utils/abacus';
import {getActionLocation, getPageType} from '../../../../utils/edap';

const getOptions = (config, locale, abacus) => {
    const {
        url: {prefix},
        site: {name: siteName, domain},
        template,
    } = config;
    const isStickySearchExperimentOn =
        getValue(abacus, TESTS.VRBO_LANDING_STICKY_SEARCHFORM) > 0;
    const actionLocation = getActionLocation(
        template,
        isStickySearchExperimentOn
    );

    const pageType = getPageType(template);
    const systemOptions = {
        site: siteName,
        baseUrl: `https://${domain}`,
        appPrefix: prefix,
        pageType,
        locale,
    };

    const edapOptions = {
        searchQuerySubmittedEventActionLocation: actionLocation,
        ...(isStickySearchExperimentOn
            ? {
                  searchSubmitEventActionLocation: actionLocation,
              }
            : {}),
    };

    const formOptions = {
        autoProgress: 'none',
        layout: 'feature',
    };

    const datesOptions = {
        actionLocation,
        dateFormatOptions: {
            day: 'numeric',
            month: 'short',
            weekday: 'short',
        },
    };

    const guestsOptions = {
        actionLocation,
    };

    const destinationOptions = {
        actionLocation,
    };

    return {
        systemOptions,
        edapOptions,
        formOptions,
        datesOptions,
        destinationOptions,
        guestsOptions,
    };
};

const getSettings = (config) => {
    const {isMobile} = config;

    const mediaSettings = {
        isMobile,
    };

    return {
        mediaSettings,
    };
};

const getStores = (config, abacus) => {
    const {template} = config;
    const pageType = getPageType(template);
    const abacusStore = {
        experimentData: abacus,
        experimentNames: [
            TESTS.HA_PTA_SEARCHBOX_AddAgeOfChildren,
            TESTS.HA_PTA_SEARCHFORM_DATES_NUMBER_OF_NIGHTS_SUMMARY,
            TESTS.VRBO_LANDING_ARIARolesOnSearchForm,
            TESTS.VRBO_LANDING_Scale_LaunchSearchFromGuestPicker,
            TESTS.VRBO_LANDING_DESTINATIONLESS_ERROR_ON_SEARCHFORM,
            TESTS.VRBO_LANDING_SEARCHFORM_DATE_FORMAT,
            TESTS.VRBO_LANDING_SEARCHFORM_DATEPICKER_DAY_OF_WEEK,
        ],
    };
    if (pageType === 'mlp') {
        abacusStore.experimentNames.push(
            TESTS.HA_PTA_SEARCHBOX_HINTTEXTCHOOSINGDATES
        );
    } else {
        abacusStore.experimentNames.push(
            TESTS.VRBO_LANDING_SCALE_HINT_TEXT_WHEN_CHOOSING_DATES
        );
    }

    return {
        abacusStore,
    };
};

const getTranslations = (labels) => {
    const {
        datePicker: {selectDateHintMessage},
    } = labels;

    const translations = {
        selectDateHintMessage,
    };

    return {
        translations,
    };
};

const getValues = (destination, search) => {
    const {propertyType, details: destinationDetails = {}} = destination;

    const {
        arrivalDate: startDate,
        departureDate: endDate,
        adults: adultsCount,
        children: childrenCount,
        petIncluded,
    } = search;

    const filterId = !isNaN(parseInt(propertyType, 10)) ? propertyType : null;

    const searchValues = {
        filters: [filterId],
    };

    const destinationValues = {
        destination: destinationDetails.fullName,
        destinationUuid: destinationDetails.lbsId,
    };

    const datesValues = {
        startDate,
        endDate,
    };

    const guestsValues = {
        adultsCount,
        childrenCount,
        petIncluded,
    };

    return {
        searchValues,
        destinationValues,
        datesValues,
        guestsValues,
    };
};

const getElementHeight = (element) => {
    if (!element.current) {
        return '0px';
    }
    return `${element.current.getBoundingClientRect().height}px`;
};

export {
    getOptions,
    getSettings,
    getStores,
    getTranslations,
    getValues,
    getElementHeight,
};
